const zeroPad = (v: number) => String(v).padStart(2, '0');

export function getTimecode(seconds: number, fps?: number | null): string {
  const safe = Number.isFinite(seconds) && seconds > 0 ? seconds : 0;
  const minutes = Math.floor((safe % 3600) / 60);
  const wholeSeconds = Math.floor(safe % 60);
  if (fps && fps > 0) {
    const frames = Math.floor((safe % 1) * fps);
    return `${zeroPad(minutes)}:${zeroPad(wholeSeconds)}:${zeroPad(frames)}`;
  }
  return `${zeroPad(minutes)}:${zeroPad(wholeSeconds)}`;
}
